import script from "./Markdown-Block.vue?vue&type=script&setup=true&lang=js"
export * from "./Markdown-Block.vue?vue&type=script&setup=true&lang=js"

import "./Markdown-Block.vue?vue&type=style&index=0&id=353a980c&lang=css"

const __exports__ = script;

export default __exports__